import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { TaskFormValues } from "components/templates/CreateTaskModal/TaskForm";

const create = (data: TaskFormValues): AxiosPromise => {
  return api.post(endpoints.ISSUES.CREATE, data);
};

const update = (id: number, data: TaskFormValues): AxiosPromise => {
  return api.put(endpoints.ISSUES.UPDATE(id), data);
};

const fetch = (filter: string): AxiosPromise<IssueApi[]> => {
  return api.get<IssueApi[]>(endpoints.ISSUES.GET(filter));
};

const changeStatus = (id: number, status: number): AxiosPromise => {
  return api.post(endpoints.ISSUES.CHANGE_STATUS(id), { status });
};

const comment = (id: number, comment: string): AxiosPromise => {
  return api.post(endpoints.ISSUES.COMMENT(id), { comment });
};

const fetchById = (id: number): AxiosPromise<IssueApi> => {
  return api.get<IssueApi>(endpoints.ISSUES.GET_BY_ID(id));
};

export const issuesApi = {
  create,
  fetch,
  changeStatus,
  fetchById,
  comment,
  update,
};

export interface IssueApi {
  id: number;
  title: string;
  description?: string;
  dueDate?: Date;
  status: number;
  link?: string;
  createdDate: Date;
  createdBy: IssueUserApi;
  assignees?: IssueUserApi[];
  activities?: IssueActivityApi[];
  issueItems?: IssueItemApi[];
}

export interface IssueActivityApi {
  issueActivityId: number;
  description: string;
  createdDate: Date;
  type: number;
  author: {
    userId: number;
    email: string;
  };
}
export interface IssueUserApi {
  id: number;
  firstName: string;
  surname: string;
  email: string;
}

export interface IssueItemApi {
  id: number;
  name: string;
  order: number;
  completed: boolean;
}
